export const PAGE_NAME = 'newuser_guide';

// 带宽
export const BANDWIDTH_TAB = 'choiceByBandwidth';
// 设备
export const DEVICE_TAB = 'choiceByDeviceType';

export const TABS = [
  {
    value: BANDWIDTH_TAB,
    label: '根据带宽选择',
  },
  {
    value: DEVICE_TAB,
    label: '根据现有设备选择',
  },
];

export const SLIDE_MARKS_TEXT = ['10M', '30M', '50M', '100M', '150M', '300M', '>300M'];
export const DEVICE_TYPES = [
  '安卓手机',
  '电脑',
  '服务器',
  'NAS',
  '平板',
  '玩客云',
  '其他',
  '了解官方硬件',
];

export const DEFAULT_SLIDER_VALUE_INDEX = 1;
